module.exports = __webpack_public_path__ + "img/telegram.f9d7d5c2.svg";